var PREFIX = 'accountid:';
var UNKNOWN_USER = 'UNKNOWN_USER';
var addPrefix = function (content) {
    return content.startsWith(PREFIX) ? content : "" + PREFIX + content;
};
export var mention = function (node, _a) {
    var context = (_a === void 0 ? {} : _a).context;
    if (node.attrs.id === UNKNOWN_USER) {
        return "[~" + node.attrs.id + "]";
    }
    var content = context &&
        context.conversion &&
        context.conversion.mentionConversion &&
        context.conversion.mentionConversion[node.attrs.id]
        ? context.conversion.mentionConversion[node.attrs.id]
        : addPrefix(node.attrs.id);
    return "[~" + content + "]";
};
//# sourceMappingURL=mention.js.map